import pkg from '../../package.json';

let defaultContactUnderWriter
try {
    defaultContactUnderWriter = JSON.parse(OE_ENV.DEFAULT_CONTACT_UNDERWRITER)
} catch (e) {
    console.error('Error while parsing ', OE_ENV.DEFAULT_CONTACT_UNDERWRITER, ':: ', e);
}

const flags = {
    SHOULD_RENDER_DOC_NUMBER: 0b0
};

export default {
    amplitudeAppToken: OE_ENV.AMPLITUDE_APP_TOKEN,
    // argoEmail: OE_ENV.ARGO_EMAIL,
    assetsURL: OE_ENV.ASSETS_URL,
    apiGatewayUrl: OE_ENV.API_GATEWAY_URL,
    argopiURL: OE_ENV.ARGOPI_URL,
    region: OE_ENV.API_GATEWAY_REGION,
    // clearanceFailEmail: OE_ENV.CLEARANCE_FAIL_EMAIL,
    // clearanceFailFlag: OE_ENV.CLEARANCE_FAIL_FLAG,
    env: OE_ENV.NODE_ENV,
    flags,
    landingPageUrl: OE_ENV.LANDING_PAGE_URL,
    name: pkg.name,
    nodeEnv: OE_ENV.NODE_ENV,
    // ownerEdgeEmail: OE_ENV.OWNERS_EDGE_EMAIL,
    // sgsOCPEmail: OE_ENV.SGS_OCP_EMAIL,
    // sgsOIEmail: OE_ENV.SGS_OI_EMAIL,
    ratingsUrl: OE_ENV.RATINGS_URL,
    defaultContactUnderWriter,
    underwriterBrokerId: OE_ENV.UNDERWRITER_BROKER_ID,
    version: pkg.version,
    whitelistQueueBucket: OE_ENV.WHITELIST_QUEUE_BUCKET
};
